export const getAppAbsoluteUrl = (path: string): string => {
  const deployPath = process.env.REACT_APP_PREVIEW_DEPLOY_PATH;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const fullPath =
    deployPath && deployPath !== ''
      ? `/${deployPath}${normalizedPath}`
      : normalizedPath;

  return new URL(fullPath, window.location.origin).toString();
};

export const withPreviewDeployPath = (absoluteUrl: string): string => {
  const deployPath = process.env.REACT_APP_PREVIEW_DEPLOY_PATH;

  if (!deployPath) {
    return absoluteUrl;
  }

  try {
    const url = new URL(absoluteUrl);
    url.pathname = `${url.pathname.replace(/\/$/, '')}/${deployPath}`;

    return url.toString();
  } catch {
    return absoluteUrl;
  }
};

export const collapseLeadingSlashes = (path: string): string =>
  path.replace(/^\/{2,}/, '/');

export const normalizeLocationLeadingSlashes = (
  location: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location,
  history: Pick<History, 'state' | 'replaceState'> = window.history,
): void => {
  const { pathname, search, hash } = location;
  const normalizedPathname = collapseLeadingSlashes(pathname);

  if (normalizedPathname === pathname) {
    return;
  }

  history.replaceState(
    history.state,
    '',
    `${normalizedPathname}${search}${hash}`,
  );
};

export const processUrl = (url: string, params: Record<string, any>) => {
  if (Object.values(params).length === 0) {
    return url;
  }

  return Object.entries(params).reduce(
    (a, [key, value]) => a.replace(`:${key}`, value),
    url,
  );
};

export const removeParamsFromPath = (
  path: string | null,
  paramsToRemove: string[],
) => {
  if (!path) {
    return '';
  }

  const urlObj = new URL(path, window.location.origin);
  const searchParams = urlObj.searchParams;

  // Remove specific parameters
  paramsToRemove.forEach((param) => searchParams.delete(param));

  // Construct the path again
  const result = `${urlObj.pathname}${
    searchParams.toString() ? `?${searchParams.toString()}` : ''
  }`;

  return result;
};
